import type { TaskActivityEntry, TaskStatus } from './types'

export function campaignStatusLabel(status: TaskStatus) {
  if (status === 'Aprovada') return 'Aprovada internamente'
  if (status === 'Reprovada') return 'Reprovada pelo cliente'
  return status
}

export function campaignStatusActivityDescription(entry: Pick<TaskActivityEntry, 'description' | 'statusChange'>) {
  if (entry.statusChange?.entity !== 'task') return entry.description
  return `alterou o status da campanha de ${campaignStatusLabel(entry.statusChange.from)} para ${campaignStatusLabel(entry.statusChange.to)}`
}
